import React, { FC } from 'react'

import { Modal, Txt, Icon } from 'src/components/atoms'
import { AddExternalUserTooltip } from 'src/components/molecules'
import { CreateExternalUser } from 'src/components/organisms'

import { useGetExternalUsers } from 'src/hooks'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const CreateExternalUserModal: FC<Props> = ({ isOpen, onClose }) => {
  const { refetch } = useGetExternalUsers()

  const handleAfterCreateUser = async () => {
    await refetch()
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-full-justify">
            <AddExternalUserTooltip>
              <div className="tw-flex tw-items-center">
                <Icon
                  size="--r1"
                  path="plus/soft/line"
                  className="tw-accent-standardText-secondary"
                />
                <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
                  社外ユーザー追加
                </Txt>
              </div>
            </AddExternalUserTooltip>
          </div>
        </div>
      }
    >
      <div className="tw-w-[56.14rem] tw-p-s2">
        <CreateExternalUser afterCreate={handleAfterCreateUser} />
      </div>
    </Modal>
  )
}
